import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import Contact from 'components/contact';

type Props = {
  data: Object,
};

const ContactPage = ({ data }: Props) => {
  const {
    contactJson,
    cookieConsentJson,
    siteJson,
    logoJson,
    socialMediaJson,
    thirdPartyAppsJson,
  } = data;

  return (
    <Website
      content={{
        ...contactJson,
        form: {
          ...contactJson.form,
          emailService: thirdPartyAppsJson.emailJs,
        },
        cookieConsent: cookieConsentJson,
        menu: siteJson?.content,
        logo: logoJson,
        socialMedia: socialMediaJson,
      }}>
      <Layout>
        <Contact />
      </Layout>
    </Website>
  );
};

export default ContactPage;

export const query = graphql`
  query ContactPageQuery {
    contactJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
      }
      intro {
        title
        text
        map {
          icon
          title
          image
          label
          locations
        }
      }
      form {
        button
        consentText
        newsletterText
      }
      clocks {
        town
        address
        timezone
        telephone
      }
      slider {
        images {
          xl
          lg
          md
          sm
          xs
        }
      }
      meta {
        description
        title
      }
    }
    thirdPartyAppsJson {
      emailJs {
        serviceId
        templateId
        userId
      }
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
  }
`;
